import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react"
import {configs, getDomainAlias} from "../../constants";



const rawBaseQuery = fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers) => {
        const token = localStorage.getItem("azureToken");
        if (token) headers.set("Authorization", `Bearer ${token}`);
        headers.set("Accept", `application/json`);
        return headers;
    }
});


const dynamicBaseQuery = async (args, api, extraOptions) => {
    // Получаем состояние из Redux store
    const isProd = api.getState().data.EnvStateData?.isProd ?? (localStorage.getItem("isProd") !== 'false');

    const domainAlias = getDomainAlias();
    const config = configs[domainAlias];

    // Вычисляем нужный URL
    const baseUrl = isProd ? config.prodUrl : config.baseUrl;

    const adjustedArgs = typeof args === 'string'
        ? `${baseUrl}${args}`
        : { ...args, url: `${baseUrl}${args.url}` };


    return rawBaseQuery(adjustedArgs, api, extraOptions);
};


const api = createApi({
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({})
})

export default api
